import { ActionReducerMap, createFeatureSelector, combineReducers, createSelector } from '@ngrx/store';
import * as fromModifyOrder from '@ordersnproducts/modules/new-modify-order/reducers/base.reducer';
import * as fromOrderSelectedDetail from '@ordersnproducts/modules/new-modify-order/reducers/order-detail.reducer';
import * as fromSpecialInvoice from '@ordersnproducts/modules/new-modify-order/reducers/special-invoice.reducer';
import * as fromModifyReason from '@ordersnproducts/modules/new-modify-order/reducers/modify-reason.reducer';
import * as fromOrderState from '@ordersnproducts/modules/new-modify-order/reducers/order.reducer';
import * as fromTopLocationState from '@ordersnproducts/modules/new-modify-order/modules/rms-top-location/reducers';
import * as fromModifyOnlineOrder from '@ordersnproducts/modules/new-modify-order/modules/new-modify-product-specification/reducers';
import { InjectionToken } from '@angular/core';
import { State } from '@cemex/cmx-client-layout';

export const modifyOrderKey = 'NewModifyOrder';

export interface ModifyFeatureState {
  modifyOrder: fromModifyOrder.ModifyOrderState;
  modifyOnlineOrder: fromModifyOnlineOrder.ModifyOnlineOrderState;
  orderSelectedDetail: fromOrderSelectedDetail.OrderSelectedDetailState;
  order: fromOrderState.OrderState;
  topLocation: fromTopLocationState.TopLocationState;
  specialInvoice: fromSpecialInvoice.SpecialInvoiceState;
  modifyReason: fromModifyReason.ModifyReasonState;
}

export interface ModifyOrderState extends State {
  ModifyOrderState: ModifyFeatureState;
}

export const reducers = {
  modifyOrder: fromModifyOrder.reducer,
  orderSelectedDetail: fromOrderSelectedDetail.reducer,
  order: fromOrderState.orderReducer,
  topLocation: fromTopLocationState.reducers,
  specialInvoice: fromSpecialInvoice.reducer,
  modifyReason: fromModifyReason.reducer,
  modifyOnlineOrder: fromModifyOnlineOrder.reducers,
};

export const combinedReducers = combineReducers({
  ...reducers,
});

export const reducerToken = new InjectionToken<ActionReducerMap<ModifyOrderState>>('COMBINED_REDUCERS');

export function getReducers() {
  return combinedReducers;
}

export const ReducerProvider = { provide: reducerToken, useFactory: getReducers };

export const getNewModifyOrderState = createFeatureSelector<ModifyFeatureState>(modifyOrderKey);

export const getOrderCode = createSelector(getNewModifyOrderState, (state) => state.order.orderCode);

export const getOrderId = createSelector(getNewModifyOrderState, (state) => state.order.orderId);

export const getOrderIdNewModify = createSelector(
  getNewModifyOrderState,
  (state) => state.orderSelectedDetail.order.orderId,
);
export const getPumpCapacitiOrderDetailNewModify = createSelector(
  getNewModifyOrderState,
  (state) => state.orderSelectedDetail,
);

export const getOrderStatusPrefillState = createSelector(
  getPumpCapacitiOrderDetailNewModify,
  (state) => state.prefilledOrder,
);

export const getOrderStatusPrefill = createSelector(
  getPumpCapacitiOrderDetailNewModify,
  (state) => !!(state && state.prefilledOrder && state.prefilledOrder.enabled),
);

export const getModifyOrder = createSelector(getNewModifyOrderState, (state) => state.order);

export const getValidateDateTime = createSelector(getNewModifyOrderState, (state) => state.order.validateDateTime);
